import { V1ListModelFamilyResponse, Wealthdistributionmodelsv1Model } from '@blk/portfolio-security-server/models';

import { ModelFamilyResponse } from './model-families-response.model';


export const flattenMetadata = (modelObject: Wealthdistributionmodelsv1Model) => {
	const metadata = { ...modelObject.metadata };
	return { id: modelObject.id, name: modelObject.name, published: modelObject.published, ...metadata };
};

export const mapModelsFamiliesResponse = (response: V1ListModelFamilyResponse): ModelFamilyResponse => {
	const responseObject = { error: response.error, nextPageToken: response.nextPageToken };
	const familiesWithModels = response.modelFamilies.filter(family => family?.models?.length > 0);
	const modelFamilies = familiesWithModels.map(family => {
		const models = family.models.map(item => flattenMetadata(item));
		return { ...flattenMetadata(family), models };
	});
	return { ...responseObject, modelFamilies };
};
